export const isUsersParticipateOrInvited = (board, usersIds) => {
    const applicationsOrParticipantIdsSet = new Set(board.applicationsOrParticipantIds);
    return usersIds.every(id => applicationsOrParticipantIdsSet.has(id));
};
